module.exports = __webpack_public_path__ + "img/settings.92cfcb54.svg";